import { BREAKPOINT, EducationPanel } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const StyledEducationPanel = styled(EducationPanel)`
  grid-template:
    'aside' auto
    'article' auto / 100%;

  @media screen and (min-width: ${BREAKPOINT.MD}px) {
    grid-template: 'article aside' auto / 60% auto;
  }
`
